import * as React from "react";
import styled from "styled-components";
import { themeGet as $ } from "@styled-system/theme-get";
import { Body } from "@quandoo-dev/cookbook/lib/typography";

interface PriceCategoryProps {
  level: number;
}

interface CurrencyProps {
  isMuted?: boolean;
}

const Currency = styled.span<CurrencyProps>`
  color: ${props =>
    props.isMuted ? $("colors.text.disabled") : $("colors.text.default")};
`;

const range = Array.from(Array(4));

const PriceCategory: React.FC<PriceCategoryProps> = ({ level }) => {
  return (
    <Body fontWeight="semibold">
      {range.map((_, i) => (
        <Currency key={i} isMuted={i >= level}>
          €
        </Currency>
      ))}
    </Body>
  );
};

export default PriceCategory;
